import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DateDataTypeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DateDataType",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26.16 5.76h-2.85V3.4c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4v2.36h-9V3.4c0-.77-.63-1.4-1.4-1.4s-1.4.63-1.4 1.4v2.36H5.87c-1.37 0-2.48 1.11-2.48 2.47v19.29A2.48 2.48 0 0 0 5.87 30h20.3c1.36 0 2.47-1.11 2.47-2.48V8.23c0-1.36-1.11-2.47-2.47-2.47Zm-1.07 21.43H6.92c-.4 0-.74-.33-.74-.74V9.19c0-.35.28-.64.64-.64h1.87v2.85c0 .77.63 1.4 1.4 1.4s1.4-.63 1.4-1.4V8.55h9v2.85c0 .77.63 1.4 1.4 1.4s1.4-.63 1.4-1.4V8.55h1.77c.4 0 .74.34.74.74v17.16c0 .4-.33.73-.73.73Z"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.02",
        height: "4.02",
        x: "8.21",
        y: "15.11",
        rx: "1.02",
        ry: "1.02"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.02",
        height: "4.02",
        x: "8.21",
        y: "20.39",
        rx: "1.02",
        ry: "1.02"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.02",
        height: "4.02",
        x: "13.94",
        y: "15.11",
        rx: "1.02",
        ry: "1.02"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.02",
        height: "4.02",
        x: "13.94",
        y: "20.39",
        rx: "1.02",
        ry: "1.02"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.02",
        height: "4.02",
        x: "19.66",
        y: "15.11",
        rx: "1.02",
        ry: "1.02"
      }), /*#__PURE__*/_jsx("rect", {
        width: "4.02",
        height: "4.02",
        x: "19.66",
        y: "20.39",
        rx: "1.02",
        ry: "1.02"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.86 8.71c-.63 0-1.14-.51-1.14-1.14V3A1.14 1.14 0 1 1 11 3v4.57c0 .63-.51 1.14-1.14 1.14M21.29 8.71c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M19 13.28H3A1.14 1.14 0 1 1 3 11h16a1.14 1.14 0 1 1 0 2.28M20.14 29.28c-.63 0-1.14-.51-1.14-1.14v-5.71c0-1.89 1.54-3.43 3.43-3.43h5.71a1.14 1.14 0 1 1 0 2.28h-5.71c-.63 0-1.14.51-1.14 1.14v5.71c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.14 29.28H5.29c-1.89 0-3.43-1.54-3.43-3.43v-9.14a1.14 1.14 0 1 1 2.28 0v9.14c0 .63.51 1.14 1.14 1.14h14.38l7.33-7.33V7.57c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v4.57a1.14 1.14 0 1 1-2.28 0V7.57c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v12.57c0 .3-.12.59-.33.81l-8 8c-.21.21-.5.33-.81.33Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 13.28H3A1.14 1.14 0 1 1 3 11h20.57a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
DateDataTypeIcon.displayName = 'DateDataTypeIcon';